export const formatWalletProviderGroupKey = (walletName: string): string =>
  walletName.replace(/[^a-zA-Z0-9]/g, '').toLowerCase();
